import React from "react";

const styles = {
  container: {
    padding: "40px 20px",
    textAlign: "center",
    backgroundColor: "#f9f9f9",
  },
  templateGrid: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "20px",
    marginTop: "30px",
  },
  templateCard: {
    backgroundColor: "#fff",
    width: "300px",
    padding: "15px",
    borderRadius: "8px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
    cursor: "pointer",
    transition: "transform 0.2s",
  },
  templateImg: {
    width: "100%",
    height: "430px",
    backgroundColor: "#ddd",
    borderRadius: "6px",
    marginBottom: "10px",
    objectFit: "cover",
  },
  templateTitle: {
    fontWeight: "bold",
    fontSize: "16px",
    marginBottom: "6px",
  },
  templateDesc: {
    fontSize: "13px",
    color: "#666",
  },
};

function TemplateSelector({ onSelectTemplate }) {
  const templates = [
    {
      name: "Template 1",
      desc: "Clean layout with blue highlights.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator2.png",
    },
    {
      name: "Template 2",
      desc: "Elegant and formal design ideal for finance or academia.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator5.png",
    },
    {
      name: "Template 3",
      desc: "Stylish and colorful for designers or artists.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator3.png",
    },
    {
      name: "Template 4",
      desc: "Simple, easy-to-read layout with clear sections.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator1.png",
    },
    {
      name: "Template 5",
      desc: "Structured and detailed. Best for leadership and management roles.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator4.png",
    },
    {
      name: "Template 6",
      desc: "Developer-centric template with skill-focused design.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator6.png",
    },
    {
      name: "Template 7",
      desc: "Modern professional layout with elegant typography.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator7.png",
    },
    {
      name: "Template 8",
      desc: "Minimalist resume style perfect for corporate jobs.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator8.png",
    },
    {
      name: "Template 9",
      desc: "Soft color design with balanced layout.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator9.png",
    },
    {
      name: "Template 10",
      desc: "Elegant modern design that highlights your experience and skills clearly.",
      img: "https://resumefuel.xyz/resume/src/images/Jobcvcreator-CV-Creator10.png",
    },
  ];

  return (
    <div style={styles.container}>
      <h2>Select a Resume Template</h2>
      <p style={{ maxWidth: "700px", margin: "0 auto", color: "#666" }}>
        Choose from our full collection of professionally designed templates.
      </p>
      <div style={styles.templateGrid}>
        {templates.map((tpl) => (
          <div
            key={tpl.name}
            style={styles.templateCard}
            onClick={() => onSelectTemplate(tpl.name)}
          >
            <img src={tpl.img} alt={tpl.name} style={styles.templateImg} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default TemplateSelector;
